// src/locales/index.ts
import { en } from "./en";
import { ko } from "./ko";

export const translations = {
  en,
  ko,
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;
